import * as React from "react";
import * as _ from "underscore";

import { connect } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { reduxForm } from "redux-form";

import { loadApp } from "web_modules/underwriter_dashboard/actions";
import * as swal from "sweetalert";

import { DocTypes } from "@eave/shared/types/api";
import APIClient from "web_modules/APIClient";
import { DocumentUploader } from "web_modules/DocumentUploader";
import OtherIncomeType from "./OtherIncomeType";

const FontAwesome = require("react-fontawesome");

const mapUnderwriterStateToProps = (state, ownProps) => {
  const loanApp: any = _.findWhere(state.operator.loanApps, {
    id: ownProps.applicationID,
  });

  return {
    documents: ownProps.documents || loanApp.documents,
    documentType: ownProps.documentType,
    prompt: ownProps.prompt,
    onUpload: ownProps.onUpload,
    ownerEntityType: ownProps.ownerEntityType,
    ownerEntityID: ownProps.ownerEntityID,
    applicationID: ownProps.applicationID,
    showOnlyCurrentUploadsOfType: ownProps.showOnlyCurrentUploadsOfType,
  };
};

const mapUnderwriterDispatchToProps = dispatch => ({
  updateApplication(dispatchType, application) {
    dispatch({
      type: "UNDERWRITER_UPDATE_APPLICATION",
      payload: application,
    });
  },
});

const UnderwriterDocumentUploader = connect(
  mapUnderwriterStateToProps,
  mapUnderwriterDispatchToProps,
)(DocumentUploader as any);

interface NewOtherIncomeFormProps {
  loanApplicationID: Number;
  additionalIncome?: any;
  onCancel: Function;
  handleSubmit: Function;
  hasCoborrower: boolean;
  dispatch?: Function;
}

class NewOtherIncomeForm extends React.Component<NewOtherIncomeFormProps, any> {
  constructor(props) {
    super(props);
    // TODO: This component needs to be reworked to be able to start without
    // an additional income in context. The document uploader needs an id to
    // upload documents. So maybe upload the document post creation?
    const additionalIncome = props.additionalIncome
      ? _.clone(props.additionalIncome)
      : {
          loan_application_id: props.loanApplicationID,
          borrower_entity: 1,
          operator_income_type: "",
          include_in_other: true,
          include_in_ratios: true,
          notes: "",
        };
    this.state = {
      additionalIncome,
      needsToBeSaved: true,
    };

    this.componentCleanup = this.componentCleanup.bind(this);
  }

  deleteIncome() {
    swal({
      title: "Are you sure you want to delete this asset?",
      icon: "warning",
      buttons: {
        cancel: true,
        confirm: "Yes I'm sure",
      },
    }).then(confirm => {
      if (confirm) {
        APIClient.deleteRequest(`/additional_income/${this.props.additionalIncome.id}`).then(() => {
          loadApp(this.props.dispatch, this.props.loanApplicationID);
        });
      }
    });
  }

  componentDidMount() {
    if (!this.props.additionalIncome) {
      window.addEventListener("beforeunload", this.componentCleanup);
      APIClient.post("/additional_income", this.state.additionalIncome).then((resp: any) => {
        this.setState({ additionalIncome: resp.additional_income });
      });
    }
  }

  componentWillUnmount() {
    if (!this.props.additionalIncome) {
      this.componentCleanup();
      window.removeEventListener("beforeunload", this.componentCleanup);
    }
  }

  componentCleanup() {
    if (this.state.needsToBeSaved && this.state.additionalIncome.id) {
      APIClient.deleteRequest(`/additional_income/${this.state.additionalIncome.id}`);
      for (const i in this.state.documentIDs) {
        APIClient.deleteRequest(`/loan_application/attachments/${this.state.documentIDs[i]}`);
      }
    }
  }

  storeDocumentIDs(documentIDs) {
    this.setState({ documentIDs });
  }

  handleSelectChange = (field, e) => {
    this.setState(prevState => ({
      ...prevState,
      additionalIncome: {
        ...prevState.additionalIncome,
        [field]: field === "borrower_entity" ? +e.value : e.value || "",
      },
    }));
  };

  onSave() {
    const { additionalIncome } = this.state;
    const { onCancel, dispatch, loanApplicationID } = this.props;
    APIClient.put(`/additional_income/${additionalIncome.id}`, additionalIncome).then(() => {
      this.setState({ needsToBeSaved: false }, () => {
        onCancel();
        loadApp(dispatch, loanApplicationID);
      });
    });
  }

  render() {
    const { handleSubmit, hasCoborrower, loanApplicationID, onCancel } = this.props;
    const { additionalIncome } = this.state;
    return (
      <div>
        {additionalIncome && <FontAwesome name="trash" onClick={this.deleteIncome.bind(this)} />}
        <br />
        <Form onSubmit={handleSubmit(this.onSave.bind(this))}>
          {hasCoborrower && (
            <>
              <label id="borrower_entity" htmlFor="borrower_entity">
                Borrower:
              </label>
              <select
                value={additionalIncome.borrower_entity}
                name="borrower_entity"
                onChange={e => this.handleSelectChange("borrower_entity", e.target)}
              >
                <option value={1}>Borrower 1</option>
                <option value={2}>Borrower 2</option>
              </select>
            </>
          )}
          <OtherIncomeType
            onChange={e => this.handleSelectChange("operator_income_type", e)}
            selectedValue={additionalIncome.operator_income_type}
          />
          <UnderwriterDocumentUploader
            documentType={DocTypes.IncomeOther}
            prompt="Upload supporting documents"
            ownerEntityType="additional_income"
            ownerEntityID={additionalIncome.id}
            applicationID={loanApplicationID}
            onUpload={this.storeDocumentIDs.bind(this)}
            showOnlyCurrentUploadsOfType={!additionalIncome}
          />
          <Button bsSize="small" type="submit">
            <i className="fa fa-check-circle" />
            Save
          </Button>
        </Form>
        <Button bsSize="small" bsStyle="warning" onClick={onCancel}>
          <i className="fa fa-times-circle" />
          Cancel
        </Button>
      </div>
    );
  }
}

const form = reduxForm({
  form: "add-other-income",
});

const mapStateToProps = (state, ownProps) => {
  if (ownProps.additionalIncome) {
    return {
      initialValues: {
        borrower_entity: ownProps.additionalIncome.borrower_entity,
      },
    };
  }
  return {};
};

export default connect(mapStateToProps)(form(NewOtherIncomeForm));
